import React from "react";

export default function PricingCard({
  type,
  points,
  pricing,
  isYearly = false,
}) {
  return (
    <div
      style={{
        width: "368px",
        height: "630px",
        background: "#FFFFFF",
        border: "1px solid rgba(19, 149, 136, 0.3)",
        boxShadow: "0px 2px 10px rgba(46, 186, 163, 0.13)",
        borderRadius: "24px",
      }}
      className="flex flex-col"
    >
      <div
        className="flex justify-center font-medium items-center h-[77px]"
        style={{
          fontStyle: "normal",
          fontWeight: 600,
          fontSize: "20px",
          lineHeight: "30px",
          color: "#139588",
          borderBottom: "1px solid rgba(19, 149, 136, 0.3)",
        }}
      >
        {type}
      </div>
      <div style={{ margin: "0 35px 0 35px" }} className="flex flex-col grow">
        <div className="flex flex-col mt-12">
          {points.map((point) => {
            return (
              <div className="flex flex-row space-x-2">
                <div className="-mt-2 font-black text-2xl">.</div>
                <div>{point}</div>
              </div>
            );
          })}
        </div>
        <div className="flex flex-col justify-end items-center mt-4 mb-6 grow">
          {pricing === "Free" && (
            <div>
              <button
                className="mt-[280px]"
                style={{
                  width: "246px",
                  height: "56px",
                  background: "#1BB5A5",
                  borderRadius: "21px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  fontSize: "24px",
                  lineHeight: "36px",
                  color: "white",
                }}
              >
                Free
              </button>
            </div>
          )}
          {pricing === "99" && (
            <div className="flex flex-col">
              <div className="flex flex-row justify-center space-x-4 mt-4 mb-6">
                {isYearly ? null : (
                  <>
                    <div
                      style={{
                        fontStyle: "normal",
                        fontWeight: 600,
                        fontSize: "32px",
                        lineHeight: "48px",
                        color: "#263238",
                      }}
                    >
                      <div className="">
                        <del style={{ textDecorationThickness: "1.5px", textDecorationColor: "red" }}>${pricing}</del>
                        <br />
                        <div className="text-xs absolute flex flex-col -mt-1">
                          <span className="text-red-600">Free</span>
                          <span className="text-red-600">(for one year)</span>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "14px",
                        fontSize: "14px",
                      }}
                      className="flex flex-col mt-3"
                    >
                      <span>Free for 1st vendor then</span>
                      <span>$99 /month / vendor/</span>
                      <span> user</span>
                    </div>
                  </>
                )}
              </div>
              <button
                style={{
                  fontStyle: "normal",
                  fontWeight: 600,
                  width: "246px",
                  height: "56px",
                  background: "#1BB5A5",
                  borderRadius: "21px",
                  fontSize: "24px",
                  lineHeight: "36px",
                  color: "white",
                }}
              >
                {isYearly ? "Contact Support" : "Get Started"}
              </button>
            </div>
          )}
          {pricing === "9" && (
            <div className="-mt-6">
              <div className="flex flex-row justify-center space-x-4 mt-4 mb-6">
                {isYearly ? null : (
                  <>
                    <div
                      style={{
                        fontStyle: "normal",
                        fontWeight: 600,
                        fontSize: "32px",
                        lineHeight: "48px",
                        color: "#263238",
                      }}
                    >
                      <div className="">
                        <del style={{ textDecorationThickness: "1.5px", textDecorationColor: "red" }}>${pricing}</del>
                        <br />
                        <div className="text-xs absolute flex flex-col -mt-1">
                          <span className="text-red-600">Free</span>
                          <span className="text-red-600">(for one year)</span>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{ lineHeight: "14px", fontSize: "14px" }}
                      className="flex flex-col mt-3"
                    >
                      <span>Free for 10 consultants and</span>
                      <span>then $9.99 / month /</span>
                      <span>consultant / user.</span>
                    </div>
                  </>
                )}
              </div>
              <button
                style={{
                  fontStyle: "normal",
                  fontWeight: 600,
                  width: "246px",
                  height: "56px",
                  background: "#1BB5A5",
                  borderRadius: "21px",
                  fontSize: "24px",
                  lineHeight: "36px",
                  color: "white",
                }}
              >
                {isYearly ? "Contact Support" : "Get Started"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
